export default {
    header: {
        title: "放置少女公式クリエイタープロジェクト",
        loading: "ロード中です...",
    },
    desc: {
        0: "「放置少女公式クリエイタープロジェクト」は、<br />これから活躍の場を広げたいクリエイター<br />の皆様を応援する企画です。<br />「放置少女」が好きで、その魅力を動画や配信で<br />発信したい——そんな思いを持つ方々が、安心して創作を続けられるよう、環境づくりをサポートします。小さな一歩から始め、活動の輪を広げていきながら、やがては【公式クリエイター】として活躍する未来を一緒に目指しましょう。",
        // 0: "「放置少女公式クリエイタープロジェクト」は、",
        // 1: "これから活躍の場を広げたいクリエイターの皆様を応援する企画です。",
        // 2: "「放置少女」が好きで、その魅力を動画や配信で",
        // 3: "発信したい——そんな思いを持つ方々が、",
        // 4: "安心して創作を続けられるよう、環境づくりをサポートします。",
        // 5: "小さな一歩から始め、活動の輪を広げていきながら、やがては",
        // 6: "【公式クリエイター】として活躍する未来を一緒に目指しましょう。",
    },
};
